export default class UserBlock {
  readonly id: number
  readonly name: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
  }
}
